import type { CityConfig } from "../city-template/types";

export const grandviewMoConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Grandview",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "grandview-mo",
  route: "/grandview-mo",
  title: "Emergency Passport Grandview, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Grandview, MO — as fast as 24 hours. Serving Southern Jackson County and the KC metro. A+ BBB rated registered State Dept. courier serving Grandview, Belton, Raymore, and south KC. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Grandview, MO",
  heroSubtitle: "Southern Jackson County family reunion in Italy with 3 days to spare? Business trip to Tokyo and your passport just expired? South KC metro corporate travel needs fast documents? We help Grandview residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Grandview%20Missouri%20southern%20Jackson%20County%20suburban%20Kansas%20City%20metropolitan%20area%20residential%20neighborhoods%20Harry%20Truman%20Farm%20historical%20site%2071%20Highway%20corridor%20Midwestern%20suburban%20landscape%20green%20spaces%20soft%20afternoon%20light%20professional%20drone%20photography%20Heartland%20community%20charm&width=1800&height=700&seq=grandview-mo-hero-2026&orientation=landscape",
  heroImageAlt: "Grandview Missouri Southern Jackson County suburban landscape at golden hour",
  geoPosition: "38.8798;-94.5266",
  geoPlacename: "Grandview, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 530 miles east of Grandview via I-70/I-55",
  },
  nearbyCitiesZips: [
    { name: "Grandview", zips: "64030" },
    { name: "Kansas City", zips: "64101–64199" },
    { name: "Belton", zips: "64012" },
    { name: "Raymore", zips: "64083" },
    { name: "Lee's Summit", zips: "64063, 64064, 64081, 64082, 64086" },
    { name: "Peculiar", zips: "64078" },
    { name: "Harrisonville", zips: "64701" },
    { name: "Greenwood", zips: "64034" },
    { name: "Loch Lloyd", zips: "64012" },
    { name: "Cleveland", zips: "64734" },
    { name: "Drexel", zips: "64742" },
    { name: "Archie", zips: "64725" },
    { name: "Adrian", zips: "64720" },
    { name: "Raytown", zips: "64133, 64138" },
    { name: "Lake Winnebago", zips: "64034" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Southern Jackson County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "South KC Metro Hub", desc: "Serving Grandview, Belton, Raymore, and Southern Jackson County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Kansas City, MO", route: "/kansas-city" },
    { name: "Fast passport renewal in Lee's Summit, MO", route: "/lees-summit" },
    { name: "Emergency passport help in Independence, MO", route: "/independence-mo" },
    { name: "Urgent passport services in Blue Springs, MO", route: "/blue-springs-mo" },
    { name: "Same-day passport help in Chicago, IL", route: "/chicago" },
    { name: "Passport courier services in Columbia, MO", route: "/columbia-mo" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Grandview remotely via secure courier. We do not have a walk-in office in Grandview — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Southern Jackson County and the South KC metro.",
  fpcOfficeAddress: "1200 Main St, Kansas City, MO 64105",
  mapEmbedUrl: "https://www.google.com/maps?q=1200+Main+St,+Kansas+City,+MO+64105&output=embed",
  fpcOfficeDistance: "Serving all of Southern Jackson County including Grandview, Belton, Raymore, and surrounding Cass County communities",
  serviceAreaIntro: "From the neighborhoods of Grandview and the growing suburbs of Belton to the executive homes of Raymore and the small-town charm of Peculiar, from the historic Harry Truman Farm site to the lakeside community of Lake Winnebago — Fast Passport Center serves the entire South Kansas City metro. We regularly help travelers from Grandview, Belton, and Raymore get their passports fast without the 8-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Grandview neighborhoods and the surrounding South KC metro area including Kansas City, Belton, Raymore, Lee's Summit, Peculiar, Harrisonville, Greenwood, and Drexel. If you are anywhere in Southern Jackson County or Cass County, we have you covered.",
  howItWorksIntro: "Most Grandview travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Grandview travelers often face an 8-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Grandview and South KC metro travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Grandview? Here are the most common ones we hear from Southern Jackson County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/drivers/",
  dmvLabel: "Missouri DOR — Driver License Bureau",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Grandview travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Patricia N.",
      location: "Grandview, MO",
      rating: 5,
      text: "Our Barcelona trip was in 3 days and my passport was expired. Fast Passport Center got my renewal in 30 hours. I never left Grandview. From 71 Highway to Las Ramblas in under a week — absolutely incredible service!",
      service: "Passport Renewal",
    },
    {
      name: "Steve K.",
      location: "Belton, MO",
      rating: 5,
      text: "Emergency business trip to Seoul with 4 days notice. Fast Passport Center's dedicated agent handled everything. The daily status updates were a game changer. Best travel document experience I've ever had.",
      service: "Emergency Passport",
    },
    {
      name: "Karen R.",
      location: "Raymore, MO",
      rating: 5,
      text: "Both kids needed first passports for our Costa Rica trip. Fast Passport Center guided us through the child passport process. Got them in 4 days. Amazing service for South KC families!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "grandview-1",
      name: "Grandview Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1510 Main St",
      city: "Grandview",
      state: "MO",
      zip: "64030",
      phone: "(816) 761-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Grandview",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Grandview facility on Main Street. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "grandview-2",
      name: "Jackson County — Truman Courthouse",
      type: "County Government Passport Acceptance",
      address: "112 W Lexington Ave",
      city: "Independence",
      state: "MO",
      zip: "64050",
      phone: "(816) 881-4483",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "20 miles north of Grandview",
      website: "https://www.jacksongov.org",
      websiteLabel: "Jackson County Recorder",
      notes: "County seat with passport acceptance services. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "grandview-3",
      name: "Belton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "512 Main St",
      city: "Belton",
      state: "MO",
      zip: "64012",
      phone: "(816) 322-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south of Grandview",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Belton and southern Cass County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "grandview-4",
      name: "Lee's Summit Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "210 SW Market St",
      city: "Lee's Summit",
      state: "MO",
      zip: "64063",
      phone: "(816) 524-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles northeast of Grandview",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lee's Summit area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "grandview-5",
      name: "Raymore Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 S Madison St",
      city: "Raymore",
      state: "MO",
      zip: "64083",
      phone: "(816) 331-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles southeast of Grandview",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Raymore and eastern Cass County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 8 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Grandview photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Jackson County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Grandview applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many South KC families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Grandview travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Grandview." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Grandview address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Grandview before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Grandview for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 8-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Grandview?", a: "Fast Passport Center offers fast passport renewal in Grandview in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Grandview?", a: "The nearest regional passport agency to Grandview is the Chicago Passport Agency, approximately 530 miles east via I-70/I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Grandview without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Grandview?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 8 hours from Grandview — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for South KC residents." },
    { q: "Do you serve the entire South KC metro area?", a: "Absolutely. Fast Passport Center serves the entire South Kansas City metro area including Grandview, Belton, Raymore, Peculiar, and surrounding communities in Jackson and Cass counties." },
    { q: "Can I expedite a child passport in Grandview?", a: "Yes. Fast Passport Center expedites child passports in Grandview for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk South KC families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Grandview with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Grandview", address: "1201 E 119th St, Grandview, MO 64030", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Grandview", address: "12015 Blue Ridge Blvd, Grandview, MO 64030", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Belton", address: "510 E North Ave, Belton, MO 64012", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart Supercenter — Raymore", address: "2015 W Foxwood Dr, Raymore, MO 64083", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — Grandview License Office",
      address: "12210 Blue Ridge Blvd, Grandview, MO 64030",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Most convenient for Grandview residents.",
      featured: true,
    },
    {
      name: "Missouri DOR — Belton License Office",
      address: "114 Congressman Dr, Belton, MO 64012",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Belton and Cass County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Harrisonville License Office",
      address: "124 W Mechanic St, Harrisonville, MO 64701",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Cass County seat. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "40 miles northwest of Grandview",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international airport with direct flights worldwide. About 45 minutes from Grandview via I-435/I-29.",
      flightUrl: "https://www.flykc.com/",
      flightLabel: "MCI Airport",
      featured: true,
    },
    {
      code: "MKC",
      name: "Charles B. Wheeler Downtown Airport",
      distance: "20 miles north of Grandview",
      address: "1000 NW Lou Holland Dr, Kansas City, MO 64116",
      note: "General aviation and regional flights. About 30 minutes from Grandview via I-435.",
      flightUrl: "https://www.flymkc.com/",
      flightLabel: "MKC Airport",
      featured: false,
    },
    {
      code: "SGF",
      name: "Springfield-Branson National Airport",
      distance: "165 miles south of Grandview",
      address: "2300 N Airport Blvd, Springfield, MO 65802",
      note: "Major airport for southwest Missouri. About 2 hours 30 minutes from Grandview via US-71/I-49.",
      flightUrl: "https://www.flyspringfield.com/",
      flightLabel: "SGF Airport",
      featured: false,
    },
  ],
};